export default __webpack_public_path__ + "static/media/Customer.082e2169.png";